import { useLang } from '../use-lang';
/**
 * 使用国际化
 * @return {funxtion} (key) => string
 */
export function useI18n(obj, lang) {
    return (key) => {
        const curLang = lang ?? useLang().lang;
        return _get(obj[curLang], key, key);
    };
}

function _get(obj, path, defaultValue) {
    if (typeof path === 'string') {
        path = path.split('.').reduce((acc, part) => {
            // 处理类似 'a[0].b.c' 的路径
            return acc.concat(part.split(/\[([^]+)\]/g).filter(Boolean));
        }, []);
    }

    // 使用数组的 reduce 函数逐级深入对象结构
    const value = path.reduce((acc, key) => {
    // 如果当前值是对象，则继续，否则返回 undefined
        return (acc !== null && acc !== undefined) ? acc[key] : undefined;
    }, obj);

    // 如果结果是 undefined，则返回默认值
    return value ?? defaultValue;
}
